import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'

import InvoiceList from './invoices/invoicelist'
import Loadable from 'react-loading-overlay'

@observer(['globals', 'invoices'])
export default class Invoices extends Component {

    constructor(props) {
        super(props)

        this.state = {
            pageTitle: '',
            loadableState: true,
            dateRange: 30
        }

        this.loadUnpaidInvoices()
    }

    loadInvoices(callback) {
        this.props.invoices.loadInvoicesByDateRange(this.state.dateRange, () => {
            this.setLoadableState(false)
            this.setState({
              pageTitle: 'Invoices - Last ' + this.state.dateRange + ' Days ($' + this.props.invoices.invoicesByDate.totalUnpaid.toFixed(2) + ' Unpaid)'
            })

            if (callback) {
                callback()
            }
        })
    }

    loadInvoicesByDateRange(dateRange) {
        this.setLoadableState(true)
        this.setState({
            dateRange: dateRange
        }, () => {
            this.loadInvoices()
        })
    }

    loadUnpaidInvoices(callback) {
      this.setLoadableState(true)
      this.props.invoices.loadUnpaidInvoices(() => {
        this.setState({
          pageTitle: 'Unpaid Invoices ($' + this.props.invoices.invoicesByDate.totalUnpaid.toFixed(2) + ' Unpaid)'
        })
        this.setLoadableState(false)

        if (callback) {
          callback()
        }
      })
    }

    loadRecentlyPaidInvoices(callback) {
      this.setLoadableState(true)
      this.props.invoices.loadRecentlyPaidInvoices(() => {
        this.setState({
          pageTitle: 'Paid Invoices ($' + this.props.invoices.invoicesByDate.totalUnpaid.toFixed(2) + ' Unpaid)'
        })

        this.setLoadableState(false)
      });

      if (callback) {
        callback()
      }
    }

    reload(callback) {
        this.loadInvoicesByDateRange(this.state.dateRange, () => {
            this.setLoadableState(false)
            if (callback != null) {
                callback()
            }
        })
    }

    setLoadableState(loadableState) {
        this.setState({
            loadableState: loadableState
        })
    }

    render() {

        return (
            <div className="right_col" role="main" style={{ height: 'inherit' }}>
                <div className="">
                    <div className="page-title">
                        <div className="title_left">
                            <Button bsSize="large" bsStyle="info" onClick={ () => { this.loadUnpaidInvoices() } }><i aria-hidden="true"></i>Unpaid</Button>
                            <Button bsSize="large" bsStyle="info" onClick={ () => { this.loadRecentlyPaidInvoices() } }><i aria-hidden="true"></i>Paid</Button>
                            <Button bsSize="large" bsStyle="success" onClick={ () => { this.loadInvoicesByDateRange(30) } }><i aria-hidden="true"></i>30 Days</Button>
                            <Button bsSize="large" bsStyle="warning" onClick={ () => { this.loadInvoicesByDateRange(60) } }><i aria-hidden="true"></i>60 days</Button>
                            <Button bsSize="large" bsStyle="danger" onClick={ () => { this.loadInvoicesByDateRange(90) } }><i aria-hidden="true"></i>90 days</Button>
                            <Button bsSize="large" bsStyle="primary" onClick={ () => { this.loadInvoicesByDateRange(120) } }><i aria-hidden="true"></i>120 days</Button>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
                        <InvoiceList data={ this.props.invoices.invoicesByDate } pageTitle={ this.state.pageTitle } setLoadableState={ this.setLoadableState.bind(this) } reload={this.reload.bind(this)} />
                    </Loadable>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/invoices.js